import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './federal-w4.component.html';
import { SignaturePadModal } from '../signature/signature-pad.component';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const FederalW4Component = {
    templateUrl,
    controller: FederalW4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        addlInputs: "<",
        ownerInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function FederalW4Controller(onboardingActionPolicy, utilityService, $uibModal, $state, $q, $scope, $rootScope, onboardingDocumentService, onboardingDocumentViewService, employeeService, stateProvinceService, localeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('5', vm.application) === 'View';
    vm.state = {
        view: 'FederalW4'
    };
    vm.fedWitholdingTypeID = 4;
    //vm.fedW4Form = {};
    vm.onShowUserProfile = onShowUserProfile;
    //vm.onShowFederalW4Signature = onShowFederalW4Signature;
    vm.onShowNext = onShowNext;
    vm.onSubmit = onSubmit;
    vm.onClose = onClose;
    vm.onSave = onSave;
    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSign = onSign;
    // variables for setting bank info state to emp address state
    vm.diffTaxState = false;
    /*vm.ISPreview = false;*/
    vm.isSigned = false;
    vm.isSaved = false;
    vm.showSavedNotification = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.matchStates = matchStates;
    //ssn variables
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ssnIsValidated = ssnIsValidated;
    vm.onEditClick = onEditClick;
    vm.fillLockedInfo = fillLockedInfo;
    vm.ssnBlur = ssnBlur;
    vm.savedData = false;
    vm.federalW4Form = {};
    vm.stateProvinces;
    vm.miToggle = true;
    //ownerview: review
    vm.reqReview = false;
    vm.canApproveForm = (rt) => canApproveForm(vm.application, rt);
    vm.disableEmpFields = true;
    vm.onRequestReview = onRequestReview;
    vm.signimage;
    vm.previewUrl;
    vm.wIToggle = false;
    vm.onWIToggle = onWIToggle;
    vm.maritalStatusMapping = [
        { id: 4, status: 'single' },
        { id: 5, status: 'married' },
        { id: 6, status: 'head-of-household' }];

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.stateProvinces = this.provinces;
        vm.federalW4Form.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                //vm.employeeBankInfo.LocaleID = locale.localeID;
                //vm.employeeBankInfo.ShowMaritalStatus = vm.employeeBankInfo.CountryID === 1;
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;

            });
        vm.userProfile = this.profile;
        vm.federalW4Form.employeeStatus = vm.maritalStatusMapping.reduce(function (result, item, index) {
            if (item.id === vm.employeeBankInfo.MaritalStatusID) {
                result = item.status;
            }
            return result;
        }, null);
        //Set MI Toggle value on load
        if (vm.addlInputs.hasOwnProperty("MIToggle")) {
            vm.miToggle = vm.addlInputs["MIToggle"] === "true";
        } else {
            onMIToggle(vm.miToggle);
        }

        if (vm.addlInputs.hasOwnProperty("WIToggle")) {
            vm.wiToggle = vm.addlInputs["WIToggle"] === "true";
        } else {
            onMIToggle(vm.wiToggle);
        }
        if (vm.savedInputs != null && vm.savedInputs.FirstNameMiddleInitial != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            //default to user profile info
            vm.federalW4Form.employeeFirstMiddleName = vm.userProfile.FirstName;
            if (vm.userProfile.MiddleName != null) {
                vm.federalW4Form.employeeMiddleName = vm.userProfile.MiddleName;
            }
            vm.federalW4Form.employeeLastName = vm.userProfile.LastName;
            vm.federalW4Form.employeeCity = vm.userProfile.HomeAddress.City;
            vm.federalW4Form.employeeZipCode = vm.userProfile.HomeAddress.PostalCode;
            vm.federalW4Form.employeeAddress = [vm.userProfile.HomeAddress.StreetLine1, vm.userProfile.HomeAddress.StreetLine2, vm.userProfile.HomeAddress.AptNum].filter(Boolean).join(', ');
            vm.federalW4Form.employeeSSN = this.employeeBankInfo?.CurrentSSN;
            vm.federalW4Form.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.userProfile.HomeAddress?.StateProvinceID);

        } else if (this.userInputs != null && this.userInputs.FirstNameMiddleInitial != null) {
            if (this.application) {
                //vm.editable = !(this.application && this.application.HasFW4Form === true && this.application.FederalW4 !== 'ReviewRequired' && this.application.FederalW4 !== 'Submitted' && this.application.FederalW4 !== 'Pending');
            }
            fillEmployee(this.userInputs);
            if (vm.application.FederalW4 === "Pending") {
                fillLockedInfo();
            }
            //add  during employer part
            //vm.federalW4Form.employerName = this.userInputs.TopmostSubform0Page10f1130;
            //vm.federalW4Form.employerAddress = this.userInputs.TopmostSubform0Page10f1130;
            //vm.federalW4Form.employment = this.userInputs.TopmostSubform0Page10f1140;
            //vm.federalW4Form.employerEIN = Number(this.userInputs.TopmostSubform0Page10f1150);

        } else {
            //vm.fedW4Form.$setDirty();
            vm.federalW4Form.employeeFirstMiddleName = vm.userProfile.FirstName;
            if (vm.userProfile.MiddleName != null) {
                vm.federalW4Form.employeeMiddleName = vm.userProfile.MiddleName;
            }
            vm.federalW4Form.employeeLastName = vm.userProfile.LastName;
            vm.federalW4Form.employeeCity = vm.userProfile.HomeAddress.City;
            vm.federalW4Form.employeeZipCode = vm.userProfile.HomeAddress.PostalCode;
            vm.federalW4Form.employeeAddress = [vm.userProfile.HomeAddress.StreetLine1, vm.userProfile.HomeAddress.StreetLine2, vm.userProfile.HomeAddress.AptNum].filter(Boolean).join(', ');
            vm.federalW4Form.employeeSSN = this.employeeBankInfo?.CurrentSSN;
            vm.federalW4Form.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.userProfile.HomeAddress?.StateProvinceID);
            vm.federalW4Form.employeeTotal = vm.employeeBankInfo?.ClaimDependants;
            if (!vm.employeeBankInfo?.MaritalStatusID) {
                vm.federalW4Form.employeeStatus = vm.maritalStatusMapping.reduce(function (result, item, index) {
                    if (item.id === vm.employeeBankInfo.MaritalStatusID) {
                        result = item.status;
                    }
                    return result;
                }, null);
            }
            //vm.federalW4Form.withholdingFed = Number(vm.employeeBankInfo.WithholdingFed ?? 0);
            //vm.federalW4Form.employeeTotal = vm.employeeBankInfo.ClaimDependants;
        }

        //check if tax state is different than address
        vm.diffTaxState = vm.employeeBankInfo.AddressStateProvinceID && vm.federalW4Form.employeeState != null && vm.federalW4Form.employeeState.StateProvinceID !== vm.employeeBankInfo.AddressStateProvinceID;
        vm.initLoadStatus = true;
        //if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
        //    vm.editable = false;
        //}
        //if (vm.application.ApplicationStatus === 'Pending' && vm.application.FederalW4 === 'Approved') {
        //    vm.editable = true;
        //}
        if (vm.ownerView) {
            if (this.userInputs != null && this.userInputs.EmployerNameAddress != null) { //owner inputs
                vm.federalW4Form.employerName = this.userInputs.Employername;
                vm.federalW4Form.employerAddress = this.userInputs.EmployerAddress;
                vm.federalW4Form.employerCity = this.userInputs.Employercity;
                vm.federalW4Form.employerState = vm.stateProvinces.find(x => x.StateName === this.userInputs.Employerstate);
                vm.federalW4Form.employerZip = this.userInputs.Employerzip;
                vm.federalW4Form.employmentDate = moment(this.userInputs.EmploymentDate, 'MM/DD/YYYY').toDate();
                vm.federalW4Form.employerEIN = this.userInputs.Ein
            } else if (vm.ownerInfo) {
                if (vm.ownerInfo.ShippingAddress) {
                    vm.federalW4Form.employerName = vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName;
                    vm.federalW4Form.employerAddress = [vm.ownerInfo.ShippingAddress.StreetLine1, vm.ownerInfo.ShippingAddress.StreetLine2, vm.ownerInfo.ShippingAddress.AptNum].filter(Boolean).join(', ');
                    vm.federalW4Form.employerCity = vm.ownerInfo.ShippingAddress.City;
                    vm.federalW4Form.employerState = vm.stateProvinces.find(x => x.StateName === vm.ownerInfo.ShippingAddress.StateName);
                    vm.federalW4Form.employerZip = vm.ownerInfo.ShippingAddress.PostalCode;
                }
                vm.federalW4Form.employmentDate = moment(vm.resolve.employeeProfile.IcdOffices[0].HireDate, 'DD/MM/YYYY').toDate();
                vm.federalW4Form.employerEIN = vm.ownerInfo.FEIN;
            }
        }
        vm.editable = resolveEditable();
        utilityService.hideLoading();
    }


    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.FederalW4;
        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        //false - shows edit button
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        // Started / Review: editable only if form hasn't been filled or needs action
        return !vm.application.HasFW4Form || formStatus === 'Pending' || formStatus === 'ReviewRequired';
    }


    function fillLockedInfo() {
        vm.federalW4Form.employeeFirstMiddleName = vm.userProfile.FirstName;
        if (vm.userProfile.MiddleName != null) {
            vm.federalW4Form.employeeMiddleName = vm.userProfile.MiddleName;
        }
        vm.federalW4Form.employeeLastName = vm.userProfile.LastName;
        vm.federalW4Form.employeeCity = vm.userProfile.HomeAddress.City;
        vm.federalW4Form.employeeZipCode = vm.userProfile.HomeAddress.PostalCode;
        vm.federalW4Form.employeeAddress = [vm.userProfile.HomeAddress.StreetLine1, vm.userProfile.HomeAddress.StreetLine2, vm.userProfile.HomeAddress.AptNum].filter(Boolean).join(', '); /*vm.userProfile.HomeAddress.StreetLine1;*/
        vm.federalW4Form.employeeSSN = vm.employeeBankInfo?.CurrentSSN;
    }

    function onEditClick() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            vm.federalW4Form.employeeFirstMiddleName = vm.userProfile.FirstName;
            if (vm.userProfile.MiddleName != null) {
                vm.federalW4Form.employeeMiddleName = vm.userProfile.MiddleName;
            }
            vm.federalW4Form.employeeLastName = vm.userProfile.LastName;
            vm.federalW4Form.employeeCity = vm.userProfile.HomeAddress.City;
            vm.federalW4Form.employeeZipCode = vm.userProfile.HomeAddress.PostalCode;
            vm.federalW4Form.employeeAddress = [vm.userProfile.HomeAddress.StreetLine1, vm.userProfile.HomeAddress.StreetLine2, vm.userProfile.HomeAddress.AptNum].filter(Boolean).join(', ');//vm.userProfile.HomeAddress.StreetLine1;
            vm.federalW4Form.employeeSSN = vm.employeeBankInfo?.CurrentSSN;
            vm.federalW4Form.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.userProfile.HomeAddress?.StateProvinceID);
        }
    }

    function fillEmployee(data) {

        vm.federalW4Form.employeeFirstMiddleName = data.FirstNameMiddleInitial;
        vm.federalW4Form.employeeMiddleName = data.MiddleName;
        vm.federalW4Form.employeeLastName = data.LastName;
        vm.federalW4Form.employeeSSN = data.Ssn;
        vm.federalW4Form.employeeAddress = [vm.userProfile.HomeAddress.StreetLine1, vm.userProfile.HomeAddress.StreetLine2, vm.userProfile.HomeAddress.AptNum].filter(Boolean).join(', ');
        vm.federalW4Form.employeeCity = data.City;
        vm.federalW4Form.employeeZipCode = data.ZipCode;
        vm.federalW4Form.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.userProfile.HomeAddress?.StateProvinceID)

        if (!vm.wiToggle) {
            vm.federalW4Form.employeeStatus = data.MaritalStatus
            /*vm.federalW4Form.employeeMultipleJobs = data.MultipleJobs*/
            //vm.federalW4Form.date = moment(data.Date, 'MM/DD/YYYY').toDate();
            vm.federalW4Form.employeeTotal = data.Step3Total !== null ? Number(data.Step3Total) : null;
            //vm.federalW4Form.withholdingFed = Number(data?.Step4ExtraWithholding ?? 0);
            vm.federalW4Form.employeeMultipleJobs = data.MultipleJobs;
            vm.federalW4Form.employeeQualifyChildren = data.Step3QualifyingChildren !== null ? Number(data.Step3QualifyingChildren) : null;
            vm.federalW4Form.employeeOtherDependent = data.Step3Dependents !== null ? Number(data.Step3Dependents) : null;
            vm.federalW4Form.employeeOtherIncome = data.Step4OtherIncome !== null ? Number(data.Step4OtherIncome) : null;
            vm.federalW4Form.employeeDeductions = data.Step4Deductions !== null ? Number(data.Step4Deductions) : null;
            vm.federalW4Form.employeeExtraWithHolding = data.Step4ExtraWithholding !== null ? Number(data.Step4ExtraWithholding) : null;
        }

        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;
            vm.prefilled = true;
        }

        //employer defaults
        if (vm.employeeProfile.IcdOffices[0].HireDate != null) {
            vm.federalW4Form.employmentDate = moment(vm.employeeProfile.IcdOffices[0].HireDate, 'DD/MM/YYYY')
        }
    }

    function onMIToggle(toggle) {
        return onSaveAddlInputs(vm.employee.EmployeeID, "MIToggle", toggle);
    }

    function onSaveAddlInputs(employeeId, fieldName, value) {
        return onboardingDocumentService.setAddlInput(employeeId, fieldName, value);
    }

    function onWIToggle() {
        //vm.wiToggle = !vm.wiToggle;
        clearWitholding();
        return onSaveAddlInputs(vm.employee.EmployeeID, "WIToggle", vm.wiToggle);
    }

    function clearWitholding() {
        vm.federalW4Form.employeeStatus = null;
        vm.federalW4Form.employeeTotal = null;
        //vm.federalW4Form.withholdingFed = Number(data?.Step4ExtraWithholding ?? 0);
        vm.federalW4Form.employeeMultipleJobs = null;
        vm.federalW4Form.employeeQualifyChildren = null;
        vm.federalW4Form.employeeOtherDependent = null;
        vm.federalW4Form.employeeOtherIncome = null;
        vm.federalW4Form.employeeDeductions = null;
        vm.federalW4Form.employeeExtraWithHolding = null;
    }

    $scope.$watch('vm.fedW4Form.$dirty', function (value) {
        // This is how we tell if there are unsaved form changes so we don't navigate away
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    function onSign() {
        return $uibModal.open({
            ...SignaturePadModal,
            resolve: {
                title: () => "Changes to Time Entry"
            }
        }).result.then(function (data) {
            vm.signimage = data;
        });
    }

    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '5');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );

    }


    function syncFormToProfile() {
        //let profilePromises = [];
        //vm.userProfile.FirstName = vm.federalW4Form.employeeFirstMiddleName
        //vm.userProfile.LastName = vm.federalW4Form.employeeLastName;
        //vm.userProfile.HomeAddress.City = vm.federalW4Form.employeeCity;
        //vm.userProfile.HomeAddress.PostalCode = vm.federalW4Form.employeeZipCode;
        //vm.userProfile.HomeAddress.StreetLine1 = vm.federalW4Form.employeeAddress;
        //vm.userProfile.HomeAddress.StateProvinceID = vm.stateProvinces.find(x => x.StateProvinceID === vm.federalW4Form.employeeState.StateProvinceID)?.StateProvinceID;
        //ssn mapping isnt required as field is disabled
        /* vm.employeeBankInfo.StateToBeTaxedIn = vm.stateProvinces.find(x => x.StateProvinceID === vm.federalW4Form.employeeState.StateProvinceID)?.StateProvinceID;*/
        vm.employeeBankInfo.FederalTaxExempt = vm.wiToggle;
        vm.employeeBankInfo.ClaimDependants = vm.federalW4Form.employeeTotal || 0;
        vm.employeeBankInfo.MultipleJobs = vm.federalW4Form.employeeMultipleJobs === 'true';
        vm.employeeBankInfo.WithholdingFed = vm.federalW4Form.withholdingFed;

        vm.employeeBankInfo.OtherIncome = vm.federalW4Form.employeeOtherIncome;
        vm.employeeBankInfo.Deductions = vm.federalW4Form.employeeDeductions;

        let withholding = vm.employeeBankInfo.EmployeeWithholdingInfos.find(x => x.WithholdingTypeID === vm.fedWitholdingTypeID);
        if (withholding != null && vm.federalW4Form.employeeExtraWithHolding != null) {
            withholding.AdditionalWithholdingAmount = vm.federalW4Form.employeeExtraWithHolding;
        } else if (withholding != null && vm.federalW4Form.employeeExtraWithHolding == null) {
            withholding = null;
            vm.employeeBankInfo.employeeExtraWithHolding = vm.employeeBankInfo.EmployeeWithholdingInfos.filter(function (x) {
                return x.WithholdingTypeID !== vm.fedWitholdingTypeID;
            });
        } else if (withholding == null && vm.federalW4Form.employeeExtraWithHolding != null) {
            withholding = { EmployeeId: vm.employee.EmployeeID, WithholdingTypeID: 4, AdditionalWithholdingAmount: vm.federalW4Form.employeeExtraWithHolding };
        }

        if (withholding != null) {
            vm.employeeBankInfo.EmployeeWithholdingInfos = vm.employeeBankInfo.EmployeeWithholdingInfos.filter(function (x) {
                return x.WithholdingTypeID !== vm.fedWitholdingTypeID;
            });
            vm.employeeBankInfo.EmployeeWithholdingInfos.push(withholding);
        }


        //vm.employeeBankInfo. = vm.federalW4Form.employeeExtraWithHolding
        if (vm.federalW4Form.employeeStatus) {
            let map1 = vm.maritalStatusMapping.find(x => x.status === vm.federalW4Form.employeeStatus)?.id;
            vm.employeeBankInfo.MaritalStatusID = vm.maritalStatus.reduce(function (result, item, index) {
                if (item.MaritalStatusID === map1) {
                    result = item.MaritalStatusID;
                }
                return result;
            }, {});
        } else if (vm.employeeBankInfo.MaritalStatusID == null) {
            vm.employeeBankInfo.MaritalStatusID = vm.maritalStatus.find(item => item.MaritalStatusID === 4).MaritalStatusID;
        }
    }



    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '5',
            FirstNameMiddleInitial: vm.federalW4Form.employeeFirstMiddleName,
            MiddleName: vm.federalW4Form.employeeMiddleName,
            LastName: vm.federalW4Form.employeeLastName,
            EmployeeSocialSecurityNumber: vm.employeeBankInfo.CurrentSSN, //vm.federalW4Form.employeeSSN,
            Address: vm.federalW4Form.employeeAddress,
            City: vm.federalW4Form.employeeCity,
            ZipCode: vm.federalW4Form.employeeZipCode,
            State: vm.federalW4Form.employeeState.Abbr,
            MaritalStatus: vm.federalW4Form.employeeStatus,
            MultipleJobs: vm.federalW4Form.employeeMultipleJobs,
            Step3QualifyingChildren: vm.federalW4Form.employeeQualifyChildren || 0,
            Step3Dependents: vm.federalW4Form.employeeOtherDependent || 0,
            Step3Total: vm.federalW4Form.employeeTotal || 0,
            Step4OtherIncome: vm.federalW4Form.employeeOtherIncome || 0,
            Step4Deductions: vm.federalW4Form.employeeDeductions || 0,
            Step4ExtraWithholding: vm.federalW4Form.employeeExtraWithHolding || 0,
            Date: moment(vm.federalW4Form.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            IsI9EmployeeMode: !vm.ownerView,
            EmployerName2: "akash kasina",
            Signature: vm.signimage
        };
        return onboardingDocumentService.save(vm.employee.UserName, formData, '0').then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.fedW4Form.$setPristine();
            return utilityService.hideLoading();
        });
    }

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "5");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowNext();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    function onSubmit() {
        //utilityService.showLoading();
        if (vm.fedW4Form && vm.fedW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return utilityService.hideLoading();
        }
        let promiseArray = [];
        let submitApplicationPromise = $q.resolve();
        //check if 
        vm.isRehireOrPostActiveEdit = vm.employeeProfile != null && (vm.employeeProfile.EmployeeStatusID === 1 || vm.employeeProfile.EmployeeStatusID === 3) && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending'
            && (vm.application.FederalW4 === 'Approved' || vm.application.FederalW4 === 'Pending');

        if ((vm.fedW4Form && vm.fedW4Form.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isRehireOrPostActiveEdit || isPendingResubmit || vm.isSigned || vm.application.FederalW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            let formData = {
                RequestTypeId: '5',
                FirstNameMiddleInitial: vm.federalW4Form.employeeFirstMiddleName,
                MiddleName: vm.federalW4Form.employeeMiddleName,
                LastName: vm.federalW4Form.employeeLastName,
                EmployeeSocialSecurityNumber: vm.employeeBankInfo.CurrentSSN, //vm.federalW4Form.employeeSSN,
                Address: vm.federalW4Form.employeeAddress,
                City: vm.federalW4Form.employeeCity,
                ZipCode: vm.federalW4Form.employeeZipCode,
                State: vm.federalW4Form.employeeState.Abbr,
                Date: moment(vm.federalW4Form.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
                IsI9EmployeeMode: !vm.ownerView,
                EmployerName2: "akash kasina",
                ExemptCheck: vm.wiToggle ? "true" : "false",
                Signature: vm.signimage
            };

            if (!vm.wiToggle) {
                let withholdingData = {
                    MaritalStatus: vm.federalW4Form.employeeStatus,
                    MultipleJobs: vm.federalW4Form.employeeMultipleJobs,
                    Step3QualifyingChildren: Number(vm.federalW4Form.employeeQualifyChildren) || 0,
                    Step3Dependents: Number(vm.federalW4Form.employeeOtherDependent) || 0,
                    Step3Total: Number(vm.federalW4Form.employeeTotal) || 0,
                    Step4OtherIncome: Number(vm.federalW4Form.employeeOtherIncome) || 0,
                    Step4Deductions: Number(vm.federalW4Form.employeeDeductions) || 0,
                    Step4ExtraWithholding: Number(vm.federalW4Form.employeeExtraWithHolding) || 0,
                }
                formData = { ...formData, ...withholdingData }
            }

            if (vm.ownerView) {
                let ownerData = {
                    Employername: vm.federalW4Form.employerName,
                    EmployerAddress: vm.federalW4Form.employerAddress,
                    Employercity: vm.federalW4Form.employerCity,
                    Employerstate: vm.federalW4Form.employerState?.Abbr,
                    Employerzip: vm.federalW4Form.employerZip,
                    EmployerCityZip: [vm.federalW4Form.employerCity, vm.federalW4Form.employerState?.Abbr, vm.federalW4Form.employerZip].filter(Boolean).join(', '),
                    EmploymentDate: moment(vm.federalW4Form.employmentDate, 'DD/MM/YYYY').format('MM/DD/YYYY'),
                    Ein: vm.federalW4Form.employerEIN
                }
                formData = { ...formData, ...ownerData }
            }
            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, '0');
            promiseArray.push(submitApplicationPromise);
            if (!vm.ownerView) {
                syncFormToProfile();
                promiseArray.push(employeeService.updateEmployeeProfile(vm.employee.EmployeeID, vm.userProfile, true));
                promiseArray.push(employeeService.updateEmployeeBankInfo(vm.employee.EmployeeID, vm.employeeBankInfo, true));
            }
        }


        if (!Array.isArray(promiseArray) || promiseArray.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowNext();
            }
        }

        const trans = $q.all(promiseArray).then((res) => {
            if (res) {
                if (vm.ownerView) {
                    return onApprove();
                } else {
                    return onShowNext();
                }
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
        //return onboardingDocumentService.resolvePromise(updatePromises, vm.onShowNext());
    }

    //instructions document
    function onDocDownload(pages) {
        utilityService.showLoading();
        //request type id: 1 for instructions doc
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', '-1', pages)
            .then(function (result) {
                utilityService.hideLoading();
                return result;
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });
    }

    function onPreviewInPage() {
        if (vm.fedW4Form && vm.fedW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '5',
            FirstNameMiddleInitial: vm.federalW4Form.employeeFirstMiddleName,
            MiddleName: vm.federalW4Form.employeeMiddleName,
            LastName: vm.federalW4Form.employeeLastName,
            EmployeeSocialSecurityNumber: vm.employeeBankInfo.CurrentSSN, //vm.federalW4Form.employeeSSN,
            Address: vm.federalW4Form.employeeAddress,
            City: vm.federalW4Form.employeeCity,
            ZipCode: vm.federalW4Form.employeeZipCode,
            State: vm.federalW4Form.employeeState.Abbr,
            Date: moment(vm.federalW4Form.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            IsI9EmployeeMode: !vm.ownerView,
            //EmployerName2: "akash kasina"
            //Signature: vm.signimage //remove signature for user to sign every time
            ExemptCheck: vm.wiToggle ? "true" : "false",
        };

        if (!vm.wiToggle) {
            let withholdingData = {
                MaritalStatus: vm.federalW4Form.employeeStatus,
                MultipleJobs: vm.federalW4Form.employeeMultipleJobs,
                Step3QualifyingChildren: Number(vm.federalW4Form.employeeQualifyChildren) || 0,
                Step3Dependents: Number(vm.federalW4Form.employeeOtherDependent) || 0,
                Step3Total: Number(vm.federalW4Form.employeeTotal) || 0,
                Step4OtherIncome: Number(vm.federalW4Form.employeeOtherIncome) || 0,
                Step4Deductions: Number(vm.federalW4Form.employeeDeductions) || 0,
                Step4ExtraWithholding: Number(vm.federalW4Form.employeeExtraWithHolding) || 0,
            }
            formData = { ...formData, ...withholdingData }
        }


        //if (vm.ownerView) {
        //    let ownerData = {
        //        EmployerNameAddress: vm.federalW4Form.employerName,
        //        EmploymentDate: moment(vm.federalW4Form.employmentDate, 'DD/MM/YYYY').format('DD/MM/YYYY'),
        //        Ein: vm.federalW4Form.employerEIN
        //    }
        //    formData = { ...formData, ...ownerData }
        //}

        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData
            , '0')
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "Federal-W4 Preview",
                        previewUrl: () => {
                            return vm.previewUrl;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                //vm.ISPreview = true;
                return onSubmit();
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });
    }

    function onPreview() {
        if (!vm.ownerView && vm.fedW4Form && vm.fedW4Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '5',
            FirstNameMiddleInitial: vm.federalW4Form.employeeFirstMiddleName,
            MiddleName: vm.federalW4Form.employeeMiddleName,
            LastName: vm.federalW4Form.employeeLastName,
            EmployeeSocialSecurityNumber: vm.employeeBankInfo.CurrentSSN, //vm.federalW4Form.employeeSSN,
            Address: vm.federalW4Form.employeeAddress,
            City: vm.federalW4Form.employeeCity,
            ZipCode: vm.federalW4Form.employeeZipCode,
            State: vm.federalW4Form.employeeState.Abbr,
            Date: moment(vm.federalW4Form.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            IsI9EmployeeMode: !vm.ownerView,
            EmployerName2: "akash kasina",
            Signature: vm.signimage,
            ExemptCheck: vm.wiToggle ? "true" : "false",
        };

        if (!vm.wiToggle) {
            let withholdingData = {
                MaritalStatus: vm.federalW4Form.employeeStatus,
                MultipleJobs: vm.federalW4Form.employeeMultipleJobs,
                Step3QualifyingChildren: Number(vm.federalW4Form.employeeQualifyChildren) || 0,
                Step3Dependents: Number(vm.federalW4Form.employeeOtherDependent) || 0,
                Step3Total: Number(vm.federalW4Form.employeeTotal) || 0,
                Step4OtherIncome: Number(vm.federalW4Form.employeeOtherIncome) || 0,
                Step4Deductions: Number(vm.federalW4Form.employeeDeductions) || 0,
                Step4ExtraWithholding: Number(vm.federalW4Form.employeeExtraWithHolding) || 0,
            }
            formData = { ...formData, ...withholdingData }
        }


        if (vm.ownerView) {
            let ownerData = {
                Employername: vm.federalW4Form.employerName,
                EmployerAddress: vm.federalW4Form.employerAddress,
                Employercity: vm.federalW4Form.employerCity,
                Employerstate: vm.federalW4Form.employerState?.Abbr,
                Employerzip: vm.federalW4Form.employerZip,
                EmployerCityZip: [vm.federalW4Form.employerCity, vm.federalW4Form.employerState?.Abbr, vm.federalW4Form.employerZip].filter(Boolean).join(', '),
                EmploymentDate: moment(vm.federalW4Form.employmentDate, 'DD/MM/YYYY').format('MM/DD/YYYY'),
                Ein: vm.federalW4Form.employerEIN
            }
            formData = { ...formData, ...ownerData }
        }

        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData
            , '0')
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "Federal-W4 Preview",
                        previewUrl: () => {
                            return vm.previewUrl;
                        },
                        allowApprove: () => {
                            return canApproveForm(vm.application, '5');
                        },
                        allowSign: () => {
                            return false;
                        }, //for pages without signature
                        showSignaturePopup: () => {
                            return vm.showSignaturePopup;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);

                if (data === 'ok') {
                    vm.employerSignimage = data.dataUrl;
                    vm.isSigned = true; //employer version
                    return onSubmit();
                }
            }).catch((err) => {
                console.log(err);
                utilityService.hideLoading();
            });

        //return onboardingDocumentService.preview(vm.employee.UserName, formData
        //    , '0')
        //    .then(function (result) {
        //        utilityService.hideLoading();
        //        vm.ISPreview = true;
        //        return result;
        //    }).catch((err) => {
        //        console.log(err);
        //        utilityService.hideLoading();
        //    });;
    }

    function onShowUserProfile() {
        if (vm.ownerView) {
            return $state.go('application-status.ownermodal.userProfile');
        } else {
            //warning for pending changes
            if (vm.fedW4Form && vm.fedW4Form.$dirty) {
                return $uibModal.open({
                    ...InfoModal,
                    resolve: {
                        notification: () => {
                            return "Your form is not completed yet. Do you want to leave?"
                        },
                        state: () => {
                            return "onboarding-document.userProfile";
                        }
                    },
                    size: 'sm',
                    backdrop: 'static'
                }).result
            }
            return $state.go('onboarding-document.userProfile');
        }
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.fedW4Form && vm.fedW4Form.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });

                }
            }, function (dismiss) {
                console.log('dismissed');
            });
        }
    }

    function onShowNext() {
        //return $state.go('onboarding-document.provinceW4', { source: 1 });
        vm.close({ $value: 'ok' });
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function matchStates() {
        vm.employeeBankInfo.StateToBeTaxedIn = vm.employeeBankInfo.AddressStateProvinceID;
        vm.federalW4Form.employeeState = vm.stateProvinces.find(x => x.StateProvinceID === vm.employeeBankInfo.StateToBeTaxedIn);
        vm.diffTaxState = true;
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }

    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}


export const FederalW4Modal = {
    component: "apexFederalW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
